<script setup>
const props = defineProps({
    selectedIdx: null,
    list: {
        type: Array,
        default() {
            return [];
        },
    },
});

const emit = defineEmits(["idxChange"]);

function handleClick(idx) {
    if (props.selectedIdx !== idx) {
        emit("idxChange", idx);
    }
}
</script>

<template>
    <div
        v-for="(item, idx) in props.list"
        :key="idx"
        class="card-container d-flex flex-row justify-content-between mt-3 mb-3"
        :class="{'active-card': props.selectedIdx === idx}"
        @click="handleClick(idx)"
    >
        <div class="d-flex flex-row">
            <div class="mr-2">
                <img v-if="item.img !== ''" class="medium-img" :src="item.img" alt=""/>
                <div v-else>Image</div>
            </div>
            <div class="d-flex flex-column justify-content-between">
                <div class="title font-weight-bold">{{ item.name }} {{ item.ages }}</div>
                <div class="small-subtitle">{{
                    item.description.length > 150
                        ? item.description.substring(0, 150) + "..."
                        : item.description
                }}
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.card-container {
    box-sizing: border-box;
    width: 100%;
    min-height: 85px;
    background: #FFFFFF;
    padding: 16px 18px;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
    border-radius: 15px;
}

.card-container.active-card {
    border: 2px solid #FFB700;
}
</style>
